import { render, staticRenderFns } from "./DbSwitch.vue?vue&type=template&id=19a2d545&scoped=true"
import script from "./DbSwitch.vue?vue&type=script&lang=js"
export * from "./DbSwitch.vue?vue&type=script&lang=js"
import style0 from "./DbSwitch.vue?vue&type=style&index=0&id=19a2d545&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19a2d545",
  null
  
)

export default component.exports